import { getFeiShuCallback } from '~/api';
import { getEnv } from '~/utils/env';

export function apiAuthFeiShu() {
  const urlObj = new URL(window.location.href);
  const searchCode = urlObj.searchParams.get('code');

  if (import.meta.client && !searchCode) {
    if (!window.h5sdk) {
      console.log('invalid h5sdk');
      console.log('please open in feishu');
      return;
    }

    // 通过error接口处理API验证失败后的回调
    window.h5sdk.error((err: any) => {
      throw ('h5sdk error:', JSON.stringify(err));
    });
    // 通过ready接口确认环境准备就绪后才能调用API
    window.h5sdk.ready(() => {
      console.log('window.h5sdk.ready');
      console.log('feishuAppId:', getEnv('feishuAppId'));
      // 调用JSAPI tt.requestAccess 获取 authorization code
      // const { setAccountList, setSession } = useChangeUser();
      const userInfo = useUserInfo();
      window.tt.requestAccess({
        appID: getEnv('feishuAppId'),
        scopeList: [],
        // 获取成功后的回调
        success(res: any) {
          getFeiShuCallback({
            code: res.code,
          })
            .then(response2 => {
              // console.log('getUserInfo succeed', JSON.stringify(response2));
              if (response2.data.action == 'register') {
                window.location.href = `/workspace/login-feishu?code=${response2.data.code}`;
              } else {
                const { setAccountList, setSession } = useChangeUser();
                // 用户账号列表
                setAccountList(response2.data.login_data);
                // 用户token
                const data = response2.data.login_data.find(
                  (item: any) => item.user_id == userInfo.value?.user_id,
                );
                // console.log(data,'-------------data')
                if (data) {
                  setSession(data);
                } else {
                  setSession(response2.data.login_data[0]);
                }
              }
            })
            .catch(function (e) {
              console.error('getFeiShuCallback: error', e);
            });
        },
        // 获取失败后的回调
        fail(err: any) {
          console.log(`getAuthCode failed, err:`, JSON.stringify(err));
        },
      });
    });
  }
}

// 方法1：检查飞书环境
export function isFeishuClient() {
  return navigator.userAgent.includes('Lark') || navigator.userAgent.includes('Feishu');
}
